"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
function getMaxListHeight(margin) {
    var headerHeight = 64;
    var footerHeight = 20;
    var searchMaskHeight = 56;
    return { maxHeight: "calc(100vh - ".concat(2 * margin + headerHeight + footerHeight + searchMaskHeight, "px)") };
}
exports.default = (0, makeStyles_1.default)(function () {
    var _a;
    return (0, styles_1.createStyles)({
        root: {
            maxHeight: '100%',
            overflow: 'hidden',
            transition: theme_1.default.transitions.easeOutFast,
        },
        item: {
            display: 'flex',
            alignContent: 'center',
            padding: '0 40px',
        },
        list: __assign(__assign({}, getMaxListHeight(80)), (_a = {}, _a[theme_1.default.breakpoints.down('md')] = getMaxListHeight(40), _a[theme_1.default.breakpoints.down('xs')] = getMaxListHeight(theme_1.default.globalPadding), _a)),
        globalPadding: {
            height: 24,
        },
        bottomMask: {
            width: '100%',
            marginTop: 'auto',
            backgroundColor: theme_1.default.colors.globalBackgroundLight,
            minHeight: 20,
        },
        searchAreaContainer: {
            padding: 0,
            width: '100%',
        },
        searchInput: {
            backgroundColor: theme_1.default.colors.globalBackgroundLight,
            padding: '16px 24px',
            borderRadius: 0,
            boxShadow: theme_1.default.shadows.medium,
            width: '100%',
            '&:after, &:before': {
                display: 'none',
            },
        },
        noResults: {
            margin: '40px 0px 24px',
            paddingLeft: 40,
        },
    });
});
